import { render } from "./ChoicesField.vue?vue&type=template&id=4bc1bacd&ts=true"
import script from "./ChoicesField.vue?vue&type=script&lang=ts"
export * from "./ChoicesField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__